import React from 'react'
import classnames from 'classnames'
import { Icon } from '@/features/Transactions/ui/MobileTransactionDetails/Icon/Icon'
import styles from '../MobileTxRow.module.scss'

export function TransactionIcon({ type, isLoading, isError }: { type: string; isError?: boolean; isLoading?: boolean }) {
  return (
    <div
      className={classnames(
        styles.txIcon,
        isLoading && styles.txIconLoading,
        isError && styles.txIconError,
      )}
    >
      <Icon type={type} />
    </div>
  )
}
